export const filterOptionByLabel = (input: string, option: any) => {
    return (option.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
}
